import React, { FC } from "react";
import { FOOTER_LINKS } from "../../../constants";
import { isMobileMedia } from "../../../utils/media";

export const Footer: FC = () => {
  return (
    <footer className="flex flex-col md:flex-row justify-between md:items-center pt-4 px-4 md:px-0 pb-[32px] md:pb-20 border-t border-slate-600 md:bg-white">
      <div
        className={`flex ${isMobileMedia() ? "flex-col" : "flex-row"} flex-wrap md:items-center gap-2 md:gap`}
      >
        {FOOTER_LINKS.map((link) => (
          <a
            href={link.href}
            key={link.text}
            className={link.className}
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </a>
        ))}
      </div>

      <div className="font-semibold text-gray-500 text-base block text-center md:text-left mt-8 md:mt-0">
        <span className="text-gray-300 mr-1">
          © {new Date().getFullYear()}
        </span>{" "}
        All rights reserved
      </div>
    </footer>
  );
};
